(function(){
  var FREE_SHIPPING_THRESHOLD_CENTS = 12500;

  function initHeader(){
    var headerSection = document.querySelector('section[data-section-type="header"]');
    if (headerSection && headerSection.classList.contains('absolute')) document.body.setAttribute('data-overlay-header','true');
    function upd(){ if (window.scrollY > 60) document.body.classList.add('ph-scrolled'); else document.body.classList.remove('ph-scrolled'); }
    upd();
    window.addEventListener('scroll', upd, {passive:true});
    window.addEventListener('resize', upd, {passive:true});
  }

  /* ============================================================
     MOBILE NAV MENU — bypasses Alpine.js for reliability
  ============================================================ */
  function initMobileMenu(){
    function openNav(){ document.body.classList.add('ph-nav-open'); }
    function closeNav(){ document.body.classList.remove('ph-nav-open'); }

    document.addEventListener('click', function(e){
      // 1. Hamburger / menu toggle button
      if (e.target.closest('[data-menu-drawer-toggle]')){
        e.preventDefault(); e.stopPropagation();
        document.body.classList.contains('ph-nav-open') ? closeNav() : openNav();
        return;
      }

      var drawer = document.querySelector('.sidebar-container');
      if (!drawer) return;

      if (drawer.contains(e.target)){
        // 2. Close button — lives in the .js-enabled header div at the top of the drawer
        if (e.target.closest('.js-enabled')){
          e.preventDefault(); e.stopPropagation();
          closeNav();
          return;
        }
        // 3. Nav link — close sidebar then let the browser follow the link
        var link = e.target.closest('a[href]');
        if (link && link.getAttribute('href') !== '#'){
          closeNav();
          // no stopPropagation — event still reaches the link so it navigates
          return;
        }
        // 4. Everything else inside drawer (accordion toggles etc.) — do nothing
      } else if (document.body.classList.contains('ph-nav-open')){
        // 5. Click outside the drawer (on backdrop) — close
        closeNav();
      }
    }, true);

    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeNav(); });
  }

  var PHCart = (function(){
    var THRESHOLD = FREE_SHIPPING_THRESHOLD_CENTS;
    function $(id){ return document.getElementById(id); }
    function fmt(cents){ var s=(cents/100).toFixed(2); return '$'+(s.slice(-3)==='.00'?s.slice(0,-3):s); }
    function updateShipping(total){ var t=$('shipping-bar-text'),f=$('shipping-bar-fill'); if(!t||!f)return; if(total>=THRESHOLD){t.textContent='You qualify for free shipping!';f.style.width='100%';}else{t.textContent=fmt(THRESHOLD-total)+' away from free shipping';f.style.width=Math.min((total/THRESHOLD)*100,100)+'%';} }
    function setCount(n){ document.querySelectorAll('#cart-count, #CartCount').forEach(function(el){ el.textContent = n>0?n:''; }); }
    function render(cart){
      var itemsEl=$('cart-drawer-items'),emptyEl=$('cart-drawer-empty'),footerEl=$('cart-drawer-footer'),subtotalEl=$('cart-drawer-subtotal');
      setCount(cart.item_count);
      if(cart.item_count===0){ if(emptyEl)emptyEl.style.display=''; if(footerEl)footerEl.style.display='none'; if(itemsEl)itemsEl.innerHTML=''; updateShipping(0); return; }
      if(emptyEl)emptyEl.style.display='none';
      if(footerEl)footerEl.style.display='';
      if(subtotalEl)subtotalEl.textContent=fmt(cart.total_price);
      updateShipping(cart.total_price);
      if(!itemsEl)return;
      itemsEl.innerHTML = cart.items.map(function(item){
        var img = item.image ? '<img src="'+item.image.replace(/(\.[^.?]+)(?:\?.*)?$/,'_300x300$1')+'" alt="" loading="lazy">' : '';
        return '<div class="cart-item" data-key="'+item.key+'"><div class="cart-item__image">'+img+'</div><div class="cart-item__info"><p class="cart-item__title">'+(item.product_title||item.title)+'</p><p class="cart-item__variant">'+(item.variant_title||'')+'</p><div class="cart-item__controls"><div class="cart-item__qty"><button class="cart-item__qty-btn" data-action="dec" data-key="'+item.key+'">−</button><span class="cart-item__qty-val">'+item.quantity+'</span><button class="cart-item__qty-btn" data-action="inc" data-key="'+item.key+'">+</button></div><span class="cart-item__price">'+fmt(item.line_price)+'</span></div><button class="cart-item__remove" data-key="'+item.key+'">Remove</button></div></div>';
      }).join('');
      itemsEl.querySelectorAll('.cart-item__qty-btn').forEach(function(btn){ btn.addEventListener('click', function(){ var k=this.dataset.key,v=parseInt(this.closest('.cart-item__qty').querySelector('.cart-item__qty-val').textContent)||1,q=this.dataset.action==='inc'?v+1:Math.max(0,v-1); changeItem(k,q); }); });
      itemsEl.querySelectorAll('.cart-item__remove').forEach(function(btn){ btn.addEventListener('click', function(){ changeItem(this.dataset.key,0); }); });
    }
    function changeItem(key,qty){ fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(render); }
    function open(){ var d=$('cart-drawer'),o=$('cart-overlay'); if(!d)return; fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){ render(cart); d.classList.add('is-open'); if(o)o.classList.add('is-visible'); document.body.classList.add('cart-open'); }); }
    function close(){ var d=$('cart-drawer'),o=$('cart-overlay'); if(!d)return; d.classList.remove('is-open'); if(o)o.classList.remove('is-visible'); document.body.classList.remove('cart-open'); }
    function init(){
      document.addEventListener('click', function(e){ var cl=e.target.closest('a[href$="/cart"], a[href*="/cart?"]'); if(cl&&!cl.closest('#cart-drawer')){e.preventDefault();e.stopPropagation();open();return;} if(e.target.closest('#cart-close')||e.target.closest('#cart-overlay'))close(); }, true);
      document.addEventListener('submit', function(e){ var f=e.target.closest('form[action$="/cart/add"], form[action*="/cart/add"]'); if(!f)return; e.preventDefault(); e.stopPropagation(); var fd=new FormData(f); fetch('/cart/add.js',{method:'POST',body:fd}).then(function(r){return r.json();}).then(function(){open();}).catch(function(){f.submit();}); }, true);
      document.addEventListener('keydown', function(e){ if(e.key==='Escape')close(); });
      fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){ setCount(cart.item_count); });
    }
    return { init: init, open: open, close: close };
  })();

  function initSizeChart(){
    var modal=document.getElementById('size-chart-modal'),overlay=document.getElementById('size-chart-overlay'),close=document.getElementById('size-chart-close');
    function open(imgUrl){ if(!modal)return; var c=document.getElementById('size-chart-content'); if(c&&imgUrl)c.innerHTML='<img src="'+imgUrl+'" alt="Size Chart">'; modal.classList.add('is-open'); if(overlay)overlay.classList.add('is-open'); document.body.style.overflow='hidden'; }
    function closeM(){ if(!modal)return; modal.classList.remove('is-open'); if(overlay)overlay.classList.remove('is-open'); document.body.style.overflow=''; }
    if(close)close.addEventListener('click', closeM);
    if(overlay)overlay.addEventListener('click', closeM);
    document.addEventListener('keydown', function(e){ if(e.key==='Escape')closeM(); });
    window.openSizeChart = open;
  }

  function initPdpGallery(){
    var gallery=document.getElementById('pdp-mobile-gallery'); if(!gallery)return;
    var wrap=document.createElement('div'); wrap.className='pdp__slider-wrap';
    gallery.parentNode.insertBefore(wrap, gallery); wrap.appendChild(gallery);
    var dotsEl=document.getElementById('pdp-mobile-dots'); if(dotsEl)wrap.appendChild(dotsEl);
    var itemCount=gallery.querySelectorAll('.pdp__mobile-gallery-item').length;
    if(itemCount>1){
      var prev=document.createElement('button'); prev.className='pdp__arrow pdp__arrow--prev'; prev.type='button'; prev.setAttribute('aria-label','Previous image'); prev.innerHTML='‹';
      var next=document.createElement('button'); next.className='pdp__arrow pdp__arrow--next'; next.type='button'; next.setAttribute('aria-label','Next image'); next.innerHTML='›';
      wrap.appendChild(prev); wrap.appendChild(next);
      prev.addEventListener('click', function(){ gallery.scrollBy({left:-gallery.offsetWidth,behavior:'smooth'}); });
      next.addEventListener('click', function(){ gallery.scrollBy({left:gallery.offsetWidth,behavior:'smooth'}); });
    }
    var dots=document.querySelectorAll('.pdp__mobile-dot');
    if(dots.length){
      gallery.addEventListener('scroll', function(){ var idx=Math.round(gallery.scrollLeft/gallery.offsetWidth); dots.forEach(function(d,i){ d.classList.toggle('is-active', i===idx); }); }, {passive:true});
      dots.forEach(function(d,i){ d.style.cursor='pointer'; d.addEventListener('click', function(){ gallery.scrollTo({left:i*gallery.offsetWidth,behavior:'smooth'}); }); });
    }
  }

  function initImageOverlayClickable(){
    document.querySelectorAll('[id*="image_with_text_overlay"]').forEach(function(sec){
      var cta = sec.querySelector('a[href]:not([href="#"])');
      if (!cta) return;
      sec.style.cursor = 'pointer';
      sec.addEventListener('click', function(e){
        if (e.target.closest('a, button')) return;
        window.location.href = cta.href;
      });
    });
  }

  function boot(){
    initHeader();
    initMobileMenu();
    PHCart.init();
    initSizeChart();
    initPdpGallery();
    initImageOverlayClickable();
    window.Cart = PHCart;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
